import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { HttpService } from 'src/app/shared/services/http.service';
import { SSO_SP_CONFIG } from 'src/app/shared/config/auth.config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit{

  title = 'msal-angular-tutorial';
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  public loginForm:FormGroup;
  crendentialBoo:boolean = false;

  constructor(private router:Router, public appService:AppService, private httpService:HttpService){
      this.loginForm = new FormGroup({
      name: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });
    localStorage.clear()
    sessionStorage.clear()

    const authUrl = `https://login.microsoftonline.com/${environment.APP_REG_TENANT_ID}/oauth2/v2.0/authorize`;
      const clientId = environment.APP_REG_CLIENT_ID;
      const redirectUri = environment.APP_REG_REDIRECT_URL;

      let url = `${authUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=openid%20offline_access%20${clientId}/.default&response_type=code&response_mode=query`
      window.location.href = url;
  }

  ngOnInit() {

    // this.onLogin();
    // this.broadcastService.inProgress$
    // .pipe(
    //   filter((status: InteractionStatus) => status === InteractionStatus.None),
    //   takeUntil(this._destroying$)
    // )
    // .subscribe(() => {
    //   this.setLoginDisplay();
    // })
  }

  onLogin(){
    let url = `https://login.microsoftonline.com/${environment.APP_REG_TENANT_ID}/oauth2/authorize?client_id=${environment.APP_REG_CLIENT_ID}&redirect_uri=${environment.APP_REG_REDIRECT_URL}&scope=${environment.APP_REG_SCOPE}&response_type=code&response_mode=query`
    window.location.href = url;
  }

  onVerifyButton(){
    this.router.navigateByUrl('/home')
  }
}
